import { Text } from "@/elements/Text"
import { CheckIcon } from "@heroicons/react/24/outline"
import clsx from "clsx"

interface Props {
  onClick: () => void
  label: string
  isSelected: boolean
}

export const DialogSelectItem: React.FC<Props> = ({ onClick, label, isSelected }) => {
  return (
    <div className="flex w-full flex-row items-center py-3">
      <div
        className="flex w-full cursor-pointer flex-row items-center justify-between rounded-md p-3 hover:bg-bg-2"
        onClick={onClick}>
        <Text>{label}</Text>
        <div
          className={clsx(
            "flex size-[24px] items-center justify-center rounded-full",
            isSelected ? "bg-fg-1" : "bg-bg-3"
          )}>
          {isSelected && <CheckIcon className="stroke-fg-inverse" height={20} width={20} />}
        </div>
      </div>
    </div>
  )
}
